/* eslint-disable */

/** select columns of table "argo.calendar_event_sequence" */
export enum ArgoCalendarEventSequenceSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

